import { captureMessage } from 'works/legacy/lib/sentry';

import type { MomentOpType } from './metrics';
import type { DomainNameType } from './subdomains';

export type MismatchPayloadType = {
  domain: DomainNameType;
  subdomain: string;
  op: MomentOpType;
  /** Moment method whose output diverged (e.g. 'format'). */
  method: string;
  inputFingerprint: string;
  /** Serialized runShadow inputs — makes the divergence reproducible. */
  inputs: string;
  momentOutput: string;
  dayjsOutput: string;
};

export function reportShadowMismatch(payload: MismatchPayloadType): void {
  const subdomainTail = payload.subdomain ? `/${payload.subdomain}` : '';
  // A divergence is an observation, not a crash — report it via captureMessage
  // (level: 'warning') instead of captureException so it stays off the error
  // dashboard/alerting while remaining a Sentry issue. The message string is kept
  // identical to the previous Error message so Sentry's per-(domain/op/method/fp)
  // grouping — and the observation skill's `moment_shadow.mismatch:true` tag query
  // — are unchanged. captureMessage mirrors sample-sender's reporting shape.
  const message = `moment_shadow mismatch: ${payload.domain}${subdomainTail} ${payload.op}.${payload.method} fp=${payload.inputFingerprint}`;
  captureMessage(message, {
    level: 'warning',
    tags: {
      'moment_shadow.mismatch': 'true',
      domain: payload.domain,
      subdomain: payload.subdomain,
      op: payload.op,
      method: payload.method,
    },
    extra: {
      inputFingerprint: payload.inputFingerprint,
      inputs: payload.inputs,
      momentOutput: payload.momentOutput,
      dayjsOutput: payload.dayjsOutput,
    },
  });
}
